module.exports = __webpack_public_path__ + "img/6.3d38e95a.jpg";